import { PostHogAnalytics } from './plugins/posthog.plugin';
import { LocalAnalytics } from './plugins/local.plugin';

import { getRuntimeEnvironment } from '@/environment/get-runtime-environment';
import { RuntimeEnvironment } from '@/environment/runtime-environment';
import { AnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/plugins/analytics-plugin.types';
import { getLogger } from '@/logger/logger';

let analyticsPlugin: AnalyticsPlugin | null = null;

export function getAnalyticsPlugin(): AnalyticsPlugin {
  if (analyticsPlugin) {
    return analyticsPlugin;
  }

  const env = getRuntimeEnvironment();

  if (env == RuntimeEnvironment.PRD) {
    try {
      analyticsPlugin = new PostHogAnalytics();
    } catch (error) {
      analyticsPlugin = new LocalAnalytics();
      const logger = getLogger('getAnalyticsPlugin');
      logger.error('Failed to initialize PostHogAnalytics, falling back to LocalAnalytics.', { error });
    }
  } else {
    analyticsPlugin = new LocalAnalytics();
  }

  return analyticsPlugin;
}

export function resetAnalyticsPlugin() {
  analyticsPlugin = null;
}
